export const Validation = {
    Name: new RegExp(/^.{1,50}$/),
    Email: new RegExp(/^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/),
    PostalCode: new RegExp(/^\d{4}$/),
    PhoneNumber: new RegExp(/(^(\+45)?(\d{8,20}$))/),
};
